import React from "react";

const LoadingOverlay = ({ text }) => {
  return (
    <div className=" absolute w-full h-full inset-0  bg-opacity-80 backdrop-blur-sm flex flex-col justify-center items-center z-[99]">
      <div className="flex space-x-2 ">
        <span className="dot w-3 h-3 bg-black rounded-full animate-bounce"></span>
        <span
          className="dot w-3 h-3 bg-black rounded-full animate-bounce"
          style={{ animationDelay: "0.2s" }}
        ></span>
        <span
          className="dot w-3 h-3 bg-black rounded-full animate-bounce"
          style={{ animationDelay: "0.4s" }}
        ></span>
      </div>
      <div>
        <span className="text-md  text-black-900">{text}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
